
import axios from 'axios'
const state = {
  modalDialog: false,
  dialog: false,
  me: [],
  alertText: '',
  pageName: '',
  
  errorModal: {
    title: false,
    message: false,
    callback: false
  },
  loadingAskWaitFlag: false,
  errorModalFlag: false,
  loadingIndicatorFlag: false,
  drawer: false
}
import config from '@/../config'
const defaultErrorHandler = (error =>  Promise.reject(error.response))

const mutations = {

  SET_ALERT_TEXT (state, payload) {
    state.alertText = payload
  },

  SET_LOADING_INDICATOR_FLAG (state, payload) {
    state.loadingIndicatorFlag = payload
  },

  SET_PAGENAME (state, payload) {
    state.pageName = payload
  },
  
  SET_ME (state, payload) {
    state.me = payload
  },

  SET_ERROR_MODAL (state, payload) {
    state.errorModal = payload
  },

  SET_ERROR_MODAL_FLAG (state, payload) {
    state.errorModalFlag = payload
  },

  SET_LOADING_ASK_WAIT_FLAG (state, payload) {
    state.loadingAskWaitFlag = payload
  },
  
  SET_DRAWER (state, payload) {
    state.drawer = payload
  },
  
  GET_DRAWER (state) {
    return state.drawer;
  }
}

const actions = {

}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/main.js